import app from 'flarum/app';
import UserPage from 'flarum/components/UserPage';
import LinkedFormFill from '../components/LinkedFormFill';
import LoadingIndicator from '../components/LoadingIndicator';

/* global m */

export default class ProfilePage extends UserPage {
    init() {
        super.init();

        this.loadUser(m.route.param('username'));
    }

    show(user) {
        // The form should already be in the store because it's a user relation
        // We can simply look by slug because the slug will contain the UID if there is no slug
        // We need to do this in show() because the data will only be added to the store once the user was loaded by loadUser()
        const seoId = m.route.param('form');
        this.form = app.store.getBy('formulaire-forms', 'seoId', seoId);

        // Call super.show afterwards, since it will trigger a redraw
        super.show(user);
    }

    content() {
        return this.form ? LinkedFormFill.component({
            // Necessary to force the fields to re-render when switching between multiple forms in profile
            key: this.form.id(),
            form: this.form,
            linked: this.user,
        }) : LoadingIndicator.component();
    }
}
